<template>
  <SidebarCard productName="Rate Connect" :header="$t('tbs_home_rc_promo')" :logo="RateConnectLogo">
    <ul class="tw:list-disc tw:pl-6 tw:text-sm tw:mb-3">
      <li v-for="feature in features" :key="feature">{{ $t(feature) }}</li>
    </ul>

    <BaseLink to="/rate-connect" @click="triggerEvent" class="tw:font-bold tw:text-blue-700">{{
      $t('tbs_mp_learn_more_cta')
    }}</BaseLink>
  </SidebarCard>
</template>
<script setup>
import BaseLink from '@/components/BaseLink.vue'
import SidebarCard from '@/components/homePage/sidebar/SidebarCard.vue'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const RateConnectLogo = new URL('/src/assets/img/landing/landing_rate_connect.svg', import.meta.url)

const features = ['tbs_home_rc_promo_1', 'tbs_home_rc_promo_2', 'tbs_home_rc_promo_3', 'tbs_home_rc_promo_4']

const triggerEvent = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_SIDEBAR_RATE_CONNECT_LEARN_MORE_CLICKED, {
    accommodationId: selectedAccommodationId.value,
  })
}
</script>
